import Page from "webPage/Page";
import ScrollMagic from "scrollmagic";
import "scrollmagic/scrollmagic/minified/plugins/animation.gsap.min";
import {animation, Power0, TimelineMax, TweenMax} from "gsap";
import {scrollMagicActive} from "index";

let parallaxController = null;
let howWeWorkTween;
let howWeWorkScene;
let philosophyTween;
let philosophyScene;
let tailoredApproachTween;
let tailoredApproachScene;

Page.register(['/how-we-work'], () => {
    parallaxController = new ScrollMagic.Controller();

    howWeWorkTween = new TimelineMax()
        .add([
            //TweenMax.fromTo('.js-how-we-work', 1, {yPercent: 30, xPercent: 0}, {yPercent: -20, xPercent: 0, ease: Power0.easeNone}),
        ]);

    howWeWorkScene = new ScrollMagic.Scene({
        triggerElement: '.overlap--center-how-we-work .overlap__image',
        duration: howWeWorkGetHeight,
        triggerHook: "onEnter"
    }).setTween(howWeWorkTween).addTo(parallaxController);

    philosophyTween = new TimelineMax()
        .add([
            TweenMax.fromTo('.js-floating-product', 1, {yPercent: 20, xPercent: 0}, {yPercent: -20, xPercent: 0, ease: Power0.easeNone}),
        ]);

    philosophyScene = new ScrollMagic.Scene({
        triggerElement: '.content--our-philosophy .content__holder',
        duration: philosophyGetHeight,
        triggerHook: "onEnter"
    }).setTween(philosophyTween).addTo(parallaxController);

    tailoredApproachTween = new TimelineMax()
        .add([
            //TweenMax.fromTo('.js-tailored-approach', 1, {yPercent: 20, xPercent: 0}, {yPercent: -15, xPercent: 0, ease: Power0.easeNone}),
        ]);

    tailoredApproachScene = new ScrollMagic.Scene({
        triggerElement: '.overlap--tailored-approach',
        duration: tailoredApproachGetHeight,
        triggerHook: "onEnter"
    }).setTween(tailoredApproachTween).addTo(parallaxController);

    windowResizeIndex();
    $(window).on('resize', windowResizeIndex);
});

function windowResizeIndex() {

    if (parallaxController === null) return;

    let enabled = scrollMagicActive();

    howWeWorkScene.enabled(enabled);
    tailoredApproachScene.enabled(enabled);
    philosophyScene.enabled(enabled);

    if (enabled) {
        howWeWorkScene.update(true);
        tailoredApproachScene.update(true);
        philosophyScene.update(true);
    } else {
        $('.js-how-we-work').attr('style', '');
        $('.js-tailored-approach').attr('style', '');
        $('.js-floating-product').attr('style', '');
    }
}

function howWeWorkGetHeight() {
    return $('.overlap--center-how-we-work .overlap__image').outerHeight() * 2;
}

function philosophyGetHeight() {
    return $('.content--our-philosophy .content__holder').outerHeight() * 2;
}

function tailoredApproachGetHeight() {
    return $('.overlap--tailored-approach').outerHeight() * 2;
}
